import { Users, CheckCircle2, Clock, AlertTriangle, XCircle, LogOut } from "lucide-react";

const ICONS = {
  total_expected: Users,
  present: CheckCircle2,
  late: Clock,
  late_arrival: AlertTriangle,
  absent: XCircle,
  signed_out: LogOut,
};

const STYLES = {
  total_expected: { bg: "bg-white", border: "border-slate-200", text: "text-slate-900", icon: "text-slate-500", label: "text-slate-500" },
  present: { bg: "bg-white", border: "border-emerald-200", text: "text-emerald-700", icon: "text-emerald-600", label: "text-emerald-700" },
  late: { bg: "bg-white", border: "border-amber-200", text: "text-amber-700", icon: "text-amber-600", label: "text-amber-700" },
  late_arrival: { bg: "bg-white", border: "border-orange-200", text: "text-orange-700", icon: "text-orange-600", label: "text-orange-700" },
  signed_out: { bg: "bg-white", border: "border-blue-200", text: "text-blue-700", icon: "text-blue-600", label: "text-blue-700" },
  absent: { bg: "bg-red-600", border: "border-red-700", text: "text-white", icon: "text-white", label: "text-red-100" },
};

const LABELS = {
  total_expected: "Total Expected",
  present: "Present",
  late: "Late",
  late_arrival: "Late Arrival",
  absent: "Absent",
  signed_out: "Signed Out",
};

export default function SummaryCard({ kind, value, onClick, active }) {
  const s = STYLES[kind];
  const Icon = ICONS[kind];
  const ringClass = active ? "ring-2 ring-blue-500 ring-offset-2" : "";
  const isAbsentEmphasis = kind === "absent";
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={`card-${kind}`}
      className={`text-left rounded-2xl border ${s.border} ${s.bg} p-3 sm:p-5 transition hover:-translate-y-0.5 hover:shadow-lg ${ringClass} ${isAbsentEmphasis ? "shadow-md" : ""}`}
    >
      <div className="flex items-center justify-between mb-1 sm:mb-2 gap-1">
        <span className={`text-[10px] sm:text-[11px] font-bold uppercase tracking-[0.14em] sm:tracking-[0.18em] ${s.label} truncate`}>{LABELS[kind]}</span>
        <Icon className={`w-4 h-4 sm:w-5 sm:h-5 shrink-0 ${s.icon}`} />
      </div>
      <div className={`font-display ${isAbsentEmphasis ? "text-3xl sm:text-5xl" : "text-2xl sm:text-4xl"} font-extrabold tabular-nums ${s.text}`}>
        {value ?? 0}
      </div>
    </button>
  );
}
